export default {
    loginTitle: 'ورود کاربر',
    enterInformation: 'لطفا اطلاعات حساب کاربری خود را وارد کنید',
    welcomeLogin: 'خوش آمدید ، لطفاً به حساب خود وارد شوید.',
    username: 'نام کاربری',
    password: 'رمز عبور',
    confirmation: 'تکرار رمز عبور',
    loginButton: 'ورود به سیستم',
    forgetPassword: 'رمز عبور خود را فراموش کرده اید؟',
    rememberMe: 'مرا به خاطر بسپار',
    login: 'ورود',
    newUser: 'کاربر جدید هستید؟',
    createAnAccount: 'ایجاد حساب کاربری',
    profile: 'پروفایل',
    logout: 'خروج',
    contact: 'تلفن',
    role: 'نقش',
    createdAt: 'تاریخ ایجاد',
    changePassword: 'تغییر رمز عبور',
    newPassword: 'رمز عبور جدید',
    oldPassword: 'رمز عبور قدیمی',
    backToProfile:'بازگشت به پروفایل'

}